import { Stack, Typography } from "@mui/material";

import { useRuleWizardContext } from "../../providers/RuleWizardProvider";

import WizardStepper from "./stepper/WizardStepper";
import { WizardHeaderNameStack } from "./styled/rule-wizard.styled";

export default function RuleWizardHeader() {
	const { name, activeStep } = useRuleWizardContext();

	if (activeStep === 0) {
		return (
			<Stack direction="row" spacing={2} sx={{ alignItems: "flex-start"}}>
				<WizardStepper/>
			</Stack>
		);
	} else {
		return (
			<Stack direction="row" spacing={4}>
				<WizardHeaderNameStack direction="column" spacing={1} sx={{ marginTop: "18px!important"}}>
					<Typography variant="h6" sx={{ fontWeight: "600"}}>{name}</Typography>
				</WizardHeaderNameStack>
				<WizardStepper/>
			</Stack>
		);
	}
}